import React from 'react'
import './DescriptionBox.css'
const DescriptionBox = () => {
  return (
    <div className='descriptionbox'>
      <div className="descriptionbox-navigator">
        <div className="descriptionbox-nav-box">
Description
        </div>
        <div className="descriptionbox-nav-box-fade">
            Reviews (122)
            </div>
            <div className="descriptionbox-description">
                <p>
                Sarathi – Where Nature Meets Art 🌿🎨
                </p>
                <p>
                Discover a unique collection of plants, handicrafts, and art, crafted with care and sustainability in mind. Each product brings beauty, tradition, and creativity into your space. Handmade, eco-friendly, and authentic—shop with Sarathi today! 🛍️✨
                </p>
            </div>
      </div>
    </div>
  )
}

export default DescriptionBox
